import phoneValidator from "@/hooks/formValidators/phoneValidator";
import { z } from "@/utils/zod";
import { ZodRawShape, ZodSchema } from "zod";
import agreementValidator from "@/hooks/formValidators/agreementValidator";
import { AgreementsDataType } from "@/types/AgreementsDataType";

const addValidators = (
  schema: object,
  agreements: Array<AgreementsDataType>,
): object => {
  agreements.forEach((agreement) => {
    if (agreement.agreements) {
      schema = addValidators(schema, agreement.agreements);
    } else {
      const agreementSchema = Object.fromEntries(
        new Map([
          [
            "agreement" + agreement.id,
            agreement.isRequired || agreement.isStatement
              ? agreementValidator
              : z.boolean().or(z.string()),
          ],
        ]),
      );
      schema = { ...schema, ...agreementSchema };
    }
  });

  return schema;
};

const getLeadSchema = (
  agreements: undefined | Array<AgreementsDataType>,
): ZodSchema => {
  let agreementsValidationSchema: object = {};
  if (agreements) {
    agreementsValidationSchema = addValidators(
      agreementsValidationSchema,
      agreements,
    );
  }

  return z.object({
    firstName: z.string().min(1, "Pole wymagane").max(32),
    phone: z.string().min(1, "Pole wymagane").and(phoneValidator),
    email: z.string().email().optional(),
    message: z.string().optional(),
    ...(agreementsValidationSchema as ZodRawShape),
  });
};

export default getLeadSchema;
